<template>

    <div class="flex justify-content-end mb-2">
        <Button label="Go to Formulas" @click="goBack" />
    </div>

    <Accordion :activeIndex="state.activeTab">
        <AccordionTab header="General Information">
            <div class="grid">
                <div class="form-field col">
                    <label for="code">Code</label>
                    <InputText maxlength = "255" v-model="state.formula.code" placeholder="Enter unique formula code" :disabled="true" />
                    <!-- <small class="p-invalid" v-if="state.submitted && !state.formula.code">Formula Code is required.</small> -->
                </div>
                <div class="form-field col">
                    <label for="type">Type</label>
                    <Dropdown v-model="state.formula.type" :options="state.types" optionLabel="name" optionValue="id" placeholder="Select Formula Type" />
                    <!-- <small class="p-invalid" v-if="state.submitted && !state.formula.type">Formula Type is required.</small> -->
                </div>
            </div>
            <div class="form-field">
                <label for="description">Description</label>
                <Textarea rows="5" v-model="state.formula.description" />
            </div>
        </AccordionTab>
        <AccordionTab header="Formula Builder">
            <div class="container shadow-2 surface-card">
                <formula-builder :shared="props.shared" @submit-formula="submitFormula" />
            </div>
        </AccordionTab>
    </Accordion>
</template>

<script setup>
import { reactive, onMounted, watch, defineProps } from 'vue';
import FormulaBuilder from '@/components/formula/FormulaBuilder.vue';
import useFormulaComposable from '@/composables/FormulaComposable';
import useFormulaBuilderComposable from '@/composables/FormulaBuilderComposable';
import { getFormulaTypes } from '@/helpers/enum-helpers';
import { generateUnderscoreCode } from '@/helpers/text-formatter';
import { SharedTypes } from '@/enums';
import router from '../../router';

const props = defineProps({
    id: {
        type: String,
    },
    shared: {
        type: String,
        default: 'Company',
    },
});

const { formula, fetchFormula, updateFormula } = useFormulaComposable();
const { getFormattedFormulaArray, formulaJsonToLayout } = useFormulaBuilderComposable();

const createInitialState = () => {
    return reactive({
        shared: formula.value.company_id ? SharedTypes.COMPANY : SharedTypes.SHARED,
        activeTab: 0,
        types: getFormulaTypes(),
        formula: {},
    });
};

const state = createInitialState();

function goBack() {
    router.push({ name: 'Formula' });
}

onMounted(async () => {
    // if (props.id) {
    await fetchFormula(props.id, props.shared);
    state.formula = {
        id: formula.value.id,
        company_id: formula.value.company_id,
        code: formula.value.code,
        description: formula.value.description,
        type: parseInt(formula.value.type),
        formula: [],
    };
    // converts the formula from db extracted formula to gridlayout format similarly how its initially created
    await formulaJsonToLayout(formula.value.formula);
});

watch(
    () => state.formula.code,
    (newValue) => {
        state.formula.code = generateUnderscoreCode(newValue);
    }
);

const submitFormula = async () => {
    // const formulaBody = await getTestFormulaBody(sortedLayout.value);
    // const formulaValid = await testFormula(formulaBody);
    // if (formulaValid) {
    state.formula.formula = getFormattedFormulaArray();
    const formulaUpdated = await updateFormula(state.formula.id, state.formula);
    if (formulaUpdated) {
        setTimeout(() => {
            formula.value = {};
            router.push({ name: 'Formula' });
        }, 1000);
    }
    // }
};
</script>

<style scoped>
.right-column {
    padding: 1rem;
}
.container > div {
    padding: 1rem;
}

.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}
</style>
